var map = {
	"./1-1.svg": "6802",
	"./1-2.svg": "fba0",
	"./1-3.svg": "f2d3",
	"./1-4.svg": "c573",
	"./1-5.svg": "e183",
	"./2-1.svg": "7a81",
	"./2-2.svg": "65f4",
	"./2-3.svg": "b26c",
	"./2-4.svg": "8f0d",
	"./2-5.svg": "eac0",
	"./3-1.svg": "c733",
	"./3-2.svg": "5d20",
	"./3-3.svg": "56b1",
	"./3-4.svg": "e65b",
	"./3-5.svg": "2176",
	"./4-1.svg": "79ca",
	"./4-2.svg": "11fb",
	"./4-3.svg": "4de0",
	"./4-4.svg": "83d8",
	"./4-5.svg": "46ea",
	"./5-1.svg": "7965",
	"./5-2.svg": "a079",
	"./5-3.svg": "9276",
	"./5-4.svg": "c6d3",
	"./5-5.svg": "5d64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19f6";